<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="reProjectName" clearable>
        <el-input v-model.trim="searchForm.reProjectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" prop="reOldContractNum" clearable>
        <el-input v-model.trim="searchForm.reOldContractNum" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="reNewContractNum">
        <el-input v-model.trim="searchForm.reNewContractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="外销:" prop="reSalesPersonName">
        <el-input v-model.trim="searchForm.reSalesPersonName" placeholder="请输入外销" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="orderUnitName">
        <el-input v-model.trim="searchForm.orderUnitName" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="isLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="isLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="oppName" label="操作" width="100" align="left" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" @click="handel(scope.row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="rProjectName" label="项目名称" align="left" min-width="200" />
        <el-table-column prop="rOldContractNum" label="原合同编号" align="left" min-width="140" />
        <el-table-column prop="rNewContractNum" label="合同编号" align="left" min-width="140" />
        <el-table-column prop="rContractType" label="合同类型" align="left" min-width="150" />
        <el-table-column prop="orderUnitName" label="代理商名称" align="left" min-width="150" />
        <el-table-column prop="rSalesPersonName" label="外销" align="left" min-width="100" />
        <el-table-column prop="rCreatedTime" label="合同时间" align="left" min-width="150">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.rCreatedTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="htfj" label="合同附件" align="left" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="htfj(scope.row)">
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- <el-dialog title="合同附件" :visible.sync="DialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
      <contract-file :contract-id="num" :is-init="true" v-if="DialogVisible" :is-show="false" />
    </el-dialog> -->
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="num" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
// import contractFile from './../Chief/commom/file.vue';
import contractAttachment from './../Chief/commom/fileDialog.vue';
import { financeList } from '@/API';
export default {
  data () {
    return {
      searchForm: {
        reProjectName: '',
        reOldContractNum: '',
        reNewContractNum: '',
        rCreatedTime: '',
        reSalesPersonName: '',
        contractStatus: 2,
        createBeginTime: '',
        createEndTime: ''
      },
      num: '',
      contractId: '',
      isLoading: false,
      contractVisible: false,
      tableData: [
      ],
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    // contractFile
    contractAttachment
  },
  computed: {

  },
  methods: {
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    dateFormat (time) {
      let date = new Date(time);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
    doSearch () {
      this.isLoading = true;
      let parmas = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      financeList(parmas).then((res) => {
        this.isLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.list;
          this.page.currentPage = data.pageNum;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },

    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    handel (row) {
      this.$router.push({ name: 'financeThhListHandel', query: { contratType: row.rContractType, contractId: row.rContractId } });
    },
    htfj (row) {
      // this.$router.push({ name: 'checkHt' });
      this.num = row.rContractId;
      this.contractVisible = true;
    }
  },
  mounted () {
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
